<template>
  <div>
    <div v-if="leftText || rightText" class="d-flex justify-content-between">
      <div>
        <span v-if="leftText">{{ leftText }}</span
        ><span v-if="leftSubText" class="text-muted ms-1"
          >({{ leftSubText }})</span
        >
      </div>

      <span v-if="rightText" class="text-lighter">{{ rightText }}</span>
    </div>
    <div class="d-flex justify-content-center">
      <div class="progress flex-grow-1 align-self-center">
        <div
          class="progress-bar p-1"
          :class="getClasses(color, variant)"
          :style="{
            width: percentage + '%',
          }"
        ></div>
      </div>
      <div v-if="endText" class="text-end ms-1 p-1 text-xs text-lighter">
        {{ endText }}
      </div>
      <button
        v-if="percentage <= 0"
        type="button"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        :title="tooltipText"
        class="btn p-0 my-0 ms-2 me-2"
      >
        <icon-red-alert class="align-self-center" />
      </button>
    </div>
  </div>
</template>

<script>
import IconRedAlert from "@/shared/Controls/Icons/IconRedAlert.vue";
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";

export default {
  name: "ArgonProgressWithAlert",
  components: {
    IconRedAlert,
  },
  props: {
    leftText: {
      type: String,
      default: "",
    },
    leftSubText: {
      type: String,
      default: "",
    },
    rightText: {
      type: String,
      default: "",
    },
    endText: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    variant: {
      type: String,
      default: "fill",
    },
    percentage: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },
  methods: {
    getClasses: (color, variant) => {
      let colorValue;

      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else {
        colorValue = `bg-${color}`;
      }

      return `${colorValue}`;
    },
  },
};
</script>
